import moment from "moment";

export const getStatusStyle = (status: string) => {
	const normalizedStatus = status?.toLowerCase().trim();
	
	switch (normalizedStatus) {
		case 'successful':
			return {
				variant: 'success' as const,
				className: 'status-success status-style',
				text: 'Successful'
			};
		case 'failed':
			return {
				variant: 'danger' as const,
				className: 'status-failed status-style',
				text: 'Failed'
			};
		case 'pending':
			return {
				variant: 'warning' as const,
				className: 'status-pending status-style',
				text: 'Pending'
			};
		default:
			return {
				variant: 'secondary' as const,
				className: 'status-unknown status-style',
				text: status || 'Unknown'
			};
	}
};

export const formatDate = (dateString: moment.MomentInput) => {
	return moment(dateString).format('DD-MM-YYYY / hh:mmA');
};

export const capitalizeFirstLetter = (string: string) => {
	if (!string) return '';
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatAmount = (price: number | bigint) => {
	return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN', minimumFractionDigits: 2 }).format(price);
};

export interface QueryBuilderOptions {
  page: number;
  perPage: number;
  searchQuery?: string;
  additionalParams?: Record<string, string>;
}

export const buildQueryParams = (options: QueryBuilderOptions): URLSearchParams => {
  const { page, perPage, searchQuery, additionalParams = {} } = options;
  
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString(),
    ...additionalParams,
  });
  
  if (searchQuery?.trim()) {
    params.set('searchQuery', searchQuery.trim());
  }
  
  return params;
};

